import { create } from "zustand";
import { persist } from "zustand/middleware";

const TAX_YEAR_MONTHLY_INIT_KEY = "selected-tax-year-monthly-init";

const getCurrentMonthMarker = () => {
  const currentDate = new Date();
  return `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(
    2,
    "0"
  )}`;
};

type TaxYearStore = {
  selectedTaxYear?: number;
  setSelectedTaxYear: (year: number) => void;
  clearSelectedTaxYear: () => void;
  isFirstLoginInCurrentMonth: () => boolean;
  markCurrentMonthInitialized: () => void;
};

export const useTaxYearStore = create<TaxYearStore>()(
  persist(
    (set) => ({
      selectedTaxYear: undefined,
      setSelectedTaxYear: (year) => set({ selectedTaxYear: year }),
      clearSelectedTaxYear: () => set({ selectedTaxYear: undefined }),
      isFirstLoginInCurrentMonth: () => {
        const monthMarker = getCurrentMonthMarker();
        const lastInitializedMonth = localStorage.getItem(TAX_YEAR_MONTHLY_INIT_KEY);
        return lastInitializedMonth !== monthMarker;
      },
      markCurrentMonthInitialized: () => {
        localStorage.setItem(TAX_YEAR_MONTHLY_INIT_KEY, getCurrentMonthMarker());
      },
    }),
    {
      name: "selected-tax-year",
      version: 1,
      migrate: (persistedState, version) => {
        if (version === 0) {
          return {
            ...(persistedState as Partial<TaxYearStore>),
            selectedTaxYear: undefined,
          };
        }

        return persistedState as Partial<TaxYearStore>;
      },
    }
  )
);
